<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党建宣传</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								size="small"
								placeholder="请输入内容"
								prefix-icon="el-icon-search"
								v-model="getdata.title"
								style="width: 200px;"
								@input="getdata.page = 1;totalPage = 0;dataList();">
							</el-input>
							<el-select placeholder="请选择类型" 
								v-model="getdata.type"
								clearable
								size="small"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								style="margin-left: 10px;width: 120px;">
								<el-option label="党员风采" value="1"></el-option>
								<el-option label="组织风采" value="2"></el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="addZbfc">新增</el-button>
							<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey=""
							@selectList="selectList"
                            :tableHeader="tableHeader"
                            :loading="true" 
							:indexs="false"
							:selection="true"></myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Index from './mixins/index.js'
	export default {
		mixins:[Index]
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 60px;
		    width: 110px;
			object-fit: cover;
		}
	}
</style>

